<mde-popover
  #texturePopover="mdePopover"
  [mdePopoverOverlapTrigger]="true"
  class="fuse-white"
  [mdePopoverLeaveDelay]="1000">
  <img
    (click)="openTextureViewerDialog(textureLink)"
    class="texture popover"
    src="{{ cropTextureLink }}"
    [ngStyle]="{ 'object-fit': imageFit }" />
</mde-popover>

<ng-container *ngIf="!cropTextureLink && color; then showColor; else showTexture"> </ng-container>
<ng-template #showColor>
  <div class="texture color" [ngStyle]="{ 'background-color': '#' + color }"></div>
</ng-template>
<ng-template #showTexture>
  <img
    [mdePopoverTriggerFor]="texturePopover"
    mdePopoverTriggerOn="hover"
    (click)="openTextureViewerDialog(textureLink)"
    class="texture"
    src="{{ cropTextureLink }}"
    [ngStyle]="{ 'object-fit': imageFit }" />
</ng-template>
